/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {h} from 'preact';
import {PropTypes} from 'preact-compat';

import styles from '../../../css/banner.css';
import config from '../../config';
import phenixSrc from '../../../../assets/icon.png';

const MobileAppInstallationConfirmation = ({show, appInstallationLink, onConfirmUseWeb}) => (
  <div className={show ? styles.banner : styles.hidden}>
    <div className={styles.left}>
      <button className={styles.confirmUseWebButton} onClick={onConfirmUseWeb}></button>
    </div>
    <div className={styles.middle}>
      <img src={phenixSrc} className={styles.icon}/>
      <p className={styles.text}>Install our {config.environment.isIOS ? 'IOS' : config.environment.isAndroid ? 'Android' : ''} mobile app for the best experience</p>
    </div>
    <div className={styles.right}>
      <a href={appInstallationLink}>Install</a>
    </div>
  </div>
);

MobileAppInstallationConfirmation.propTypes = {
  show: PropTypes.bool,
  appInstallationLink: PropTypes.string,
  onConfirmUseWeb: PropTypes.func
};

export default MobileAppInstallationConfirmation;